import { memo } from 'react'
import cn from 'classnames'

import type { VStackProps } from './types'

import styles from './stack.module.scss'

/**
 * Вертикальная раскладка. Единственный способ задать расстояние между блоками —
 * `gap` из общей шкалы: внешних `margin` у компонентов продукта нет (CLAUDE.md, правило 8).
 */
export const VStack = memo(function VStack(props: VStackProps) {
  const {
    gap = 'MEDIUM_XS',
    align = 'STRETCH',
    justify = 'START',
    isGrow = false,
    children,
  } = props

  return (
    <div
      className={cn(
        styles.root,
        styles.column,
        styles[`gap_${gap}`],
        styles[`align_${align}`],
        styles[`justify_${justify}`],
        isGrow && styles.grow,
      )}
    >
      {children}
    </div>
  )
})
